import i18n from '@/Config/app/i18n';
import { ConversationBadgeDto } from '@/Domain/api/Conversation/dto/ConversationBadge.dto';
import { BadgeVariantProps } from '@/Domain/components/Shared/Badge/Badge';
import { languageName } from '@/Domain/helper/languageName.helper';

type BadgeVariant = NonNullable<BadgeVariantProps['variant']>;

const SENTIMENT_VARIANT: Record<string, BadgeVariant> = {
  Positive: 'success',
  Negative: 'error',
  Neutral: 'secondary',
};

const RESOLUTION_VARIANT: Record<string, BadgeVariant> = {
  confirmed_resolution: 'success',
  assumed_resolution: 'info',
  unresolved: 'warning',
  greetings_only: 'secondary',
};

export type ConversationBadgeDisplay = { label: string; variant: BadgeVariant };

export const formatConversationBadge = (badge: ConversationBadgeDto): ConversationBadgeDisplay => {
  const { kind, value } = badge;
  switch (kind) {
    case 'sentiment':
      return {
        label: i18n.t(`inbox_v2:conversation_details.sentiment.type.${value.toLowerCase()}`, value),
        variant: SENTIMENT_VARIANT[value] ?? 'secondary',
      };
    case 'resolution':
      return {
        label: i18n.t(`inbox_v2:conversation_details.unified_analytics.${value}`, value),
        variant: RESOLUTION_VARIANT[value] ?? 'secondary',
      };
    case 'intent':
      return { label: i18n.t(`insights_page:user_intent.${value}`, value), variant: 'secondary' };
    case 'channel':
      return { label: i18n.t(`inbox_v2:sources.${value}`, value), variant: 'outline' };
    case 'metadata':
      return { label: value, variant: 'info' };
    case 'language':
      return { label: languageName(value), variant: 'outline' };
    default:
      return { label: value, variant: 'secondary' };
  }
};
